import React from 'react';
import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import {
  BoxPackedIcon,
  CreditCardIcon,
  ShoppingCartIcon,
} from '@nimbus-ds/icons';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';

const FeatureCardsSection = () => {
  const { t } = useTranslationWithPrefix('landing.featureCardsSection');

  const isMobile = useIsMobile();

  const getCards = () => {
    return [
      {
        title: t('cards.checkout.title'),
        description: t('cards.checkout.description'),
        icon: <ShoppingCartIcon size="large" />,
      },
      {
        title: t('cards.paymentMethods.title'),
        description: t('cards.paymentMethods.description'),
        icon: <CreditCardIcon size="large" />,
      },
      {
        title: t('cards.competitiveFees.title'),
        description: t('cards.competitiveFees.description'),
        icon: <BoxPackedIcon size="large" />,
      },
    ];
  };

  return (
    <Box marginY="8" paddingY="4">
      <Box marginY="5">
        <Title as={isMobile ? 'h3' : 'h2'}>{t('title')}</Title>
      </Box>
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
        {getCards().map((card) => (
          <Card key={card.title}>
            <Card.Header>
              <Box
                borderRadius="full"
                backgroundColor="primary-surface"
                padding="2"
                maxWidth="50px"
                maxHeight="50px"
              >
                <Icon source={card.icon} color="primary-interactive" />
              </Box>
            </Card.Header>
            <Card.Body>
              <Title as="h4">{card.title}</Title>
              <Box marginY="2">
                <Text>{card.description}</Text>
              </Box>
            </Card.Body>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default FeatureCardsSection;
